/** @format */

const ConfirmMedicalLetter = () =>
  import("../../../../pages/HQ/medicalLetters/confirmMedicalLetter.vue");

const ViewMedicalLetter = () =>
  import("../../../../pages/HQ/medicalLetters/viewMedicalLetterRequest.vue");

const MedicalLettersDash = () =>
  import("../../../../pages/HQ/medicalLetters/medicalLettersDash.vue");
const AddViewDoctor = () =>
  import("../../../../pages/HQ/medicalLetters/addViewDoctor.vue");

const medicalLettersRoutesHq = [
  {
    path: "",
    name: "hq-medicalLettersDashboard",
    component: MedicalLettersDash,
  },
  {
    path: "/view-letter/:letterId",
    name: "viewMedicalLetterHq",
    component: ViewMedicalLetter,
  },
  {
    path: "/:isMo/confirm-letter/:letterId",
    name: "confirmMedicalLetter",
    component: ConfirmMedicalLetter,
  },
  {
    path: "/view-doctor/:doctorId/:isView",
    name: "viewDoctorHq",
    component: AddViewDoctor,
  },
];

export default medicalLettersRoutesHq;
